export default "__VITE_ASSET__D_mObsym__"